import { Outlet } from '~/remix';

export default function () {
  return (
    <div className="bg-background-dark">
      <div className="mt-0">
        <div>
          <Outlet />
        </div>
      </div>
    </div>
  );
}
